import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { StatusChip } from "@/components/Badges";
import { exportCsv } from "@/lib/csv";
import { Download, Printer } from "lucide-react";
import { Link } from "react-router-dom";

export default function EscalationsInbox() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [notes, setNotes] = useState({});
  const load = () => api.get("/escalations", { params: { status: "Open" } }).then((r) => setItems(r.data.sort((a, b) => (a.class === "Critical" ? -1 : 1))));
  useEffect(() => { load(); }, []);

  const resolve = async (id) => {
    const note = notes[id];
    if (!note) return alert(t("validation_rework_required"));
    await api.patch(`/escalations/${id}`, { status: "Resolved", resolution_note: note });
    load();
  };

  const doExport = () => {
    exportCsv(
      items,
      [
        { key: "class", label: "Class" },
        { key: "status", label: "Status" },
        { key: "description", label: "Description" },
        { key: "raised_at", label: "Raised At", format: (v) => (v ? new Date(v).toLocaleString() : "") },
        { key: "resolution_note", label: "Resolution Note" },
      ],
      "escalations.csv"
    );
  };

  return (
    <div>
      <div className="eyebrow">{t("nav_escalations_inbox")}</div>
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h1 className="text-2xl font-bold" style={{ color: "var(--brand-navy)" }}>{t("open_escalations")}</h1>
        <button data-testid="esc-export-btn" onClick={doExport} className="h-10 px-3 rounded-md border border-[#1B3A5C]/15 text-sm flex items-center gap-1">
          <Download size={14} /> {t("export_csv")}
        </button>
      </div>
      <div className="mt-4 space-y-2">
        {items.map((e) => (
          <div key={e.id} data-testid={`esc-inbox-${e.id}`} className="hag-surface p-4">
            <div className="flex items-center gap-2 flex-wrap">
              <span className={`status-chip ${e.class === "Critical" ? "pace-red" : e.class === "Major" ? "pace-amber" : "pace-none"}`}>{e.class}</span>
              <StatusChip status={e.status} />
              <div className="text-xs text-[#7C8E9E] ml-auto">{new Date(e.raised_at).toLocaleString()}</div>
            </div>
            <div className="text-sm mt-2">{e.description}</div>
            <textarea
              data-testid={`esc-note-${e.id}`}
              placeholder={t("rework_instruction")}
              value={notes[e.id] || ""}
              onChange={(ev) => setNotes({ ...notes, [e.id]: ev.target.value })}
              className="mt-2 w-full h-20 p-2 border border-[#1B3A5C]/15 rounded-md text-sm"
            />
            <div className="mt-2 flex items-center gap-2 flex-wrap">
              <button data-testid={`esc-resolve-${e.id}`} onClick={() => resolve(e.id)} className="h-10 px-4 rounded-md font-semibold text-white" style={{ background: "var(--brand-navy)" }}>
                {t("resolve")}
              </button>
              <Link
                data-testid={`esc-print-${e.id}`}
                to={`/rework-slip/${e.id}`}
                target="_blank"
                className="h-10 px-4 rounded-md border border-[#1B3A5C]/15 text-sm flex items-center gap-1"
              >
                <Printer size={14} /> Print slip (A5)
              </Link>
            </div>
          </div>
        ))}
        {items.length === 0 && <div data-testid="empty-esc-inbox" className="text-sm text-[#7C8E9E]">{t("no_escalations")}</div>}
      </div>
    </div>
  );
}
